import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, Phone, MapPin, BookOpen } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white pt-12 pb-6">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo and About */}
          <div>
            <Link to="/" className="flex items-center mb-4">
              <BookOpen className="h-8 w-8 text-sage-400" />
              <span className="ml-2 text-xl font-serif font-semibold text-white">
                Casa Leahu
              </span>
            </Link>
            <p className="text-gray-400 mb-4">
              Bucurați-vă de confort și liniște în pensiunea noastră, cu vederi frumoase
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Quick Links</h3>
            <ul className="space-y-2">
              {['Home', 'Rooms', 'Book', 'Contact'].map((item) => (
                <li key={item}>
                  <Link
                    to={item === 'Home' ? '/' : `/${item.toLowerCase()}`}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="h-5 w-5 text-sage-400 mr-2 mt-0.5" />
                <span className="text-gray-400">Haieu, Romania</span>
              </li>
              <li className="flex items-center">
                <Phone className="h-5 w-5 text-sage-400 mr-2" />
                <span className="text-gray-400">0773922165</span>
              </li>
              <li className="flex items-center">
                <Mail className="h-5 w-5 text-sage-400 mr-2" />
                <a href="mailto:leahuion68@yahoo.com" className="text-gray-400 hover:text-white transition-colors">
                  leahuion68@yahoo.com
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Newsletter</h3>
            <p className="text-gray-400 mb-4">
              Subscribe to receive updates and special offers.
            </p>
            <form className="flex flex-col space-y-2">
              <input
                type="email"
                placeholder="Your email"
                className="px-4 py-2 bg-gray-800 border border-gray-700 rounded-md focus:outline-none focus:ring-2 focus:ring-sage-500 text-white"
              />
              <button
                type="submit"
                className="bg-sage-700 hover:bg-sage-800 text-white px-4 py-2 rounded-md transition-colors"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-6 text-center text-gray-500">
          <p>&copy; {new Date().getFullYear()} Casa Leahu. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;